import React from "react";

function Contact() {
  return (
    <div className="contact">
      <div className="text-center">
        <h2 className="contactTopic">Contact Janux Academy</h2>

        <p>
          Name:<span className="contactContext">Janux Academy</span>{" "}
        </p>
        <p>
          Email:
          <span className="contactContext">januxacademydev@gmail.com</span>{" "}
        </p>
        <p>
          Mobile:<span className="contactContext">+94713218308</span>{" "}
        </p>
      </div>
    </div>
  );
}

export default Contact;
